import axios from 'axios'

const BIKE = `/functions/search-bike-fields.php`

const bikeSelect = document.querySelectorAll('.j-search-bike')
const bikeBtn = document.querySelectorAll('.j-bike-search__btn')

async function updateField (item) {
	
	let type = item.target.dataset.area
	const loader = document.getElementById('search-area-loader-' + type)
	
	if(loader){
		loader.classList.add('is-active')
	}
	
	let param = item.target.value
	let update = item.target.dataset.sync
	const brandOn = document.getElementById('road-brand')
	const brandOff = document.getElementById('offroad-brand')
	const Lang = window.motostorm?.lang

	axios.get(BIKE, {
		params: {
			lang: Lang,
			field: update,
			val: param,
			brandOn: brandOn.value,
			brandOff: brandOff.value
		},
	})
	.then(resp => {
		if(resp.data.type === 1){
			const fildToUpdate = document.getElementById(resp.data.field)
			fildToUpdate.disabled = false
			fildToUpdate.innerHTML = resp.data.options
			fildToUpdate.classList.add('is-active')	
		} else if (resp.data.type === 0) {
			const btnToUpdate = document.getElementById(resp.data.btn)
			const mBtnToUpdate = document.getElementById(resp.data.Mbtn)
			
			btnToUpdate.value = resp.data.id
			btnToUpdate.dataset.sync = resp.data.criteria
			btnToUpdate.disabled = false
			mBtnToUpdate.value = resp.data.id
			mBtnToUpdate.dataset.sync = resp.data.criteria
			mBtnToUpdate.disabled = false
			
		} else if (resp.data.type === 2) {
			window.location.href = resp.data.url
		}
		if(loader){
			loader.classList.remove('is-active')
		}

	})
	.catch(err => {
		// Handle Error Here
		console.error(err);
	})
}

if(bikeSelect) {
	bikeSelect.forEach(item => {
		item.addEventListener('change', updateField)
	})	
}

if( bikeBtn ){
	bikeBtn.forEach(item => {
		item.addEventListener('click', updateField)
	})
}

/* const updateField = () => {
	let _filterInputs = []
	let _filterNames = []
	let _filterValues = {}
	let _stringInput
	let _handleSearch
	let _axiosCancelToken
	let _searchParams = {}
	let _settings
	const Lang = window.motostorm?.lang
	var page = 2

	function _addFilter(inputs) {
		_filterInputs = []
		_filterInputs = _filterInputs.concat([...inputs])
		_filterNames = [...new Set(_filterInputs.map((input) => input.name))]
	}

	function _getFilterValue(name) {
		const inputs = _filterInputs.filter((input) => input.name === name)
		if (!inputs.length) {
			return undefined
		}

		const values = inputs
			.map((input) => {
				switch (input.type) {
					case 'checkbox':
					case 'radio':

						if (input.checked) {
							return input.value
						}
						return
					case 'number':
						return parseFloat(input.value)
					default:
						return input.value
				}
			})
			.filter((value) => value)

		switch (values.length) {
			case 0:
				return undefined
			case 1:
				return values[0]
			default:
				return values[0]
		}
	}

	function _getAllFilterValues(e) {
		const r = []

		_filterNames.forEach((name, key) => {
			if (e.target.name == [name]){
				if(e.target.checked){
					r[name] = e.target.value
				}
			} else {
				const value = _getFilterValue(name)
				if (value !== undefined) {
					r[name]=value
				}
			}
		})
		return r
	}

	function _handleInputFilter(e) {
		page = 2
		_filterValues = _getAllFilterValues(e)
		_handleSearch(e)
	}
	
	function _handlePagination(e){
		if ((e.target.scrollHeight + 1) >= (e.target.scrollTop + e.target.clientHeight) && (e.target.scrollHeight - 2) <= (e.target.scrollTop + e.target.clientHeight)) {
			// qui va inserita la funzione di caricamento
			_filterValues = _getAllFilterValues(e)
			_filterValues['pagination'] =  true
			_filterValues['page_no'] =  page
			_stringInput = document.getElementById('id-header-search')
			const productsWrapper = document.querySelector('.j-search-popup__cards-grid')

			_searchParams = {
				lang: Lang,
				q: _stringInput.value,
				..._filterValues,
			}

			axios.get(ENDPOINT, {
				params: _searchParams,
			})
			.then(resp => {
				productsWrapper.innerHTML += resp.data.html
				// if res last page is true remove event listener
				if (resp.data.results.lastpage === true){
					e.target.removeEventListener('scroll', _handlePagination)
				}
			})
			.catch(err => {
				// Handle Error Here
				console.error(err);
			})
			page++
		}
	}

	function init(settings) {
		if (!settings || !settings.searchInput) {
			return
		}

		_settings = settings

		const allFilterInputs = document.querySelectorAll('.j-filter-search__input')
		
		_addFilter(allFilterInputs)
		_stringInput = settings.searchInput

		_handleSearch = debounce(async (e) => {

			if (e.type == 'keyup') {
				_filterValues = {}
			}
			
			// close everything on esc key
			if (e.keyCode === 27) {
				_axiosCancelToken?.cancel('Operation canceled due to abort.')
				e.target.value = ''
				if (settings.callback && typeof settings.callback === 'function') {
					settings.callback(null, true)
				}
			}

			if (e.target.value.length < MIN_SEARCH_LENGTH) {
				// if not enough letters for a search, return and set loading screen
				if (settings.callback && typeof settings.callback === 'function') {
					settings.callback()
				}
				return
			}

			if (typeof _axiosCancelToken != typeof undefined) {
				_axiosCancelToken.cancel('Operation canceled due to new request.')
			}

			_axiosCancelToken = axios.CancelToken.source()

			_searchParams = {
				lang: Lang,
				q: _stringInput.value,
				..._filterValues,
			}

			const res = await axios.get(ENDPOINT, {
				cancelToken: _axiosCancelToken.token,
				params: _searchParams,
			})

			if (settings.callback && typeof settings.callback === 'function') {
				destroy()
				settings.callback(res)
			}
			
			const resultsWrapper = document.querySelector('.c-search-popup__products')
			if(resultsWrapper){
				resultsWrapper.addEventListener('scroll', _handlePagination)
			}
			
		}, 250)

		_stringInput.addEventListener('keyup', _handleSearch)

		allFilterInputs.forEach(item => {
			item.addEventListener('change', _handleInputFilter)
		})		
	}
	
	function reinit() {
		init(_settings)
	}

	function destroy() {
		_stringInput.removeEventListener('keyup', _handleSearch)

		_filterInputs.forEach((input) =>
			input.removeEventListener('change', _handleInputFilter)
		)
	}

	return {
		init,
		reinit,
		destroy,
		get searchParams() {
			return _searchParams
		},
	}
} */
